import document from 'global/document';
var FullscreenApi = {};
var apiMap = [
    [
        'requestFullscreen',
        'exitFullscreen',
        'fullscreenElement',
        'fullscreenEnabled',
        'fullscreenchange',
        'fullscreenerror'
    ],
    [
        'webkitRequestFullscreen',
        'webkitExitFullscreen',
        'webkitFullscreenElement',
        'webkitFullscreenEnabled',
        'webkitfullscreenchange',
        'webkitfullscreenerror'
    ],
    [
        'webkitRequestFullScreen',
        'webkitCancelFullScreen',
        'webkitCurrentFullScreenElement',
        'webkitCancelFullScreen',
        'webkitfullscreenchange',
        'webkitfullscreenerror'
    ],
    [
        'mozRequestFullScreen',
        'mozCancelFullScreen',
        'mozFullScreenElement',
        'mozFullScreenEnabled',
        'mozfullscreenchange',
        'mozfullscreenerror'
    ],
    [
        'msRequestFullscreen',
        'msExitFullscreen',
        'msFullscreenElement',
        'msFullscreenEnabled',
        'MSFullscreenChange',
        'MSFullscreenError'
    ]
];
var specApi = apiMap[0];
var browserApi;
var prefixedAPI = false;
for (var i = 0; i < apiMap.length; i++) {
    if (apiMap[i][1] in document) {
        browserApi = apiMap[i];
        break;
    }
}
if (browserApi) {
    for (var _i = 0; _i < browserApi.length; _i++) {
        FullscreenApi[specApi[_i]] = browserApi[_i];
    }
    prefixedAPI = browserApi[0] === specApi[0];
}
export default FullscreenApi;
export {
    prefixedAPI
};